// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/admin/img/icons/small-check.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap {
    margin: 0;
}
@keyframes donut-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.easycommerce.toplevel_page_easycommerce-wizard .easycommerce-wizard-input {
    border: 1px solid var(--color-ec-border);
    padding: 15px;
    font-size: 16px;
    line-height: 19px;
    margin-top: 16px !important;
    max-width: unset;
    border-radius: 6px;
    color: var(--color-ec-body);
}
.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-wizard-input:focus {
    color: var(--color-ec-body);
    outline: unset !important;
    box-shadow: unset !important;
    border: 1px solid var(--color-ec-primary);
}
.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-wizard-input:hover {
    color: var(--color-ec-body);
}
.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-wizard-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-wizard-input::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce.toplevel_page_easycommerce-wizard #easycommerce-custom-color {
    border-radius: 50%;
    visibility: hidden;
    height: 0px;
}
.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-wizard-link:hover {
    color: var(--color-ec-primary);
}

.easycommerce.toplevel_page_easycommerce-wizard .easycommerce-checkbox-input {
    border: 1px solid var(--color-ec-border);
    width: 20px;
    height: 20px;
    box-shadow: none !important;
    margin-top: 2px;
}
.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-checkbox-input::before {
    margin: unset !important;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.easycommerce.toplevel_page_easycommerce-wizard
    .easycommerce-checkbox-input:checked {
    border: unset !important;
}
.easycommerece-confetti canvas {
    width: 100% !important;
}
.easycommerce.toplevel_page_easycommerce-wizard #adminmenumain,
.easycommerce.toplevel_page_easycommerce-wizard #wpadminbar,
.easycommerce.toplevel_page_easycommerce-wizard #wpbody-content #screen-meta,
.easycommerce.toplevel_page_easycommerce-wizard #wpbody-content .notice,
.easycommerce.toplevel_page_easycommerce-wizard #wpfooter {
    display: none !important;
}
.easycommerce.toplevel_page_easycommerce-wizard #wpcontent {
    margin: 0 !important;
}
.easycommerce.toplevel_page_easycommerce-wizard #wpbody {
    margin-top: -32px !important;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/wizard/src/css/wizard-menu.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,wCAAwC;IACxC,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;;IAEI,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;IAC5B,yCAAyC;AAC7C;AACA;;IAEI,2BAA2B;AAC/B;AACA;;IAEI,kCAAkC;AACtC;AAHA;;IAEI,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;AACA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;AACA;;IAEI,wBAAwB;IACxB,2DAA8E;AAClF;;AAEA;;IAEI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;AACA;;;;;IAKI,wBAAwB;AAC5B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,4BAA4B;AAChC","sourcesContent":[".wrap {\n    margin: 0;\n}\n@keyframes donut-spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n.easycommerce.toplevel_page_easycommerce-wizard .easycommerce-wizard-input {\n    border: 1px solid var(--color-ec-border);\n    padding: 15px;\n    font-size: 16px;\n    line-height: 19px;\n    margin-top: 16px !important;\n    max-width: unset;\n    border-radius: 6px;\n    color: var(--color-ec-body);\n}\n.easycommerce.toplevel_page_easycommerce-wizard\n    .easycommerce-wizard-input:focus {\n    color: var(--color-ec-body);\n    outline: unset !important;\n    box-shadow: unset !important;\n    border: 1px solid var(--color-ec-primary);\n}\n.easycommerce.toplevel_page_easycommerce-wizard\n    .easycommerce-wizard-input:hover {\n    color: var(--color-ec-body);\n}\n.easycommerce.toplevel_page_easycommerce-wizard\n    .easycommerce-wizard-input::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce.toplevel_page_easycommerce-wizard #easycommerce-custom-color {\n    border-radius: 50%;\n    visibility: hidden;\n    height: 0px;\n}\n.easycommerce.toplevel_page_easycommerce-wizard\n    .easycommerce-wizard-link:hover {\n    color: var(--color-ec-primary);\n}\n\n.easycommerce.toplevel_page_easycommerce-wizard .easycommerce-checkbox-input {\n    border: 1px solid var(--color-ec-border);\n    width: 20px;\n    height: 20px;\n    box-shadow: none !important;\n    margin-top: 2px;\n}\n.easycommerce.toplevel_page_easycommerce-wizard\n    .easycommerce-checkbox-input::before {\n    margin: unset !important;\n    content: url(../../../../../assets/admin/img/icons/small-check.png) !important;\n}\n\n.easycommerce.toplevel_page_easycommerce-wizard\n    .easycommerce-checkbox-input:checked {\n    border: unset !important;\n}\n.easycommerece-confetti canvas {\n    width: 100% !important;\n}\n.easycommerce.toplevel_page_easycommerce-wizard #adminmenumain,\n.easycommerce.toplevel_page_easycommerce-wizard #wpadminbar,\n.easycommerce.toplevel_page_easycommerce-wizard #wpbody-content #screen-meta,\n.easycommerce.toplevel_page_easycommerce-wizard #wpbody-content .notice,\n.easycommerce.toplevel_page_easycommerce-wizard #wpfooter {\n    display: none !important;\n}\n.easycommerce.toplevel_page_easycommerce-wizard #wpcontent {\n    margin: 0 !important;\n}\n.easycommerce.toplevel_page_easycommerce-wizard #wpbody {\n    margin-top: -32px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
